import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import CtaBlock, { CtaBlockType } from '../common/cta-block';
import Projects, { ProjectsType } from './projects';

import styles from './portfolio-page.module.scss';

const PortfolioPage = ({ children, topCtaBlock, bottomCtaBlock, projects }) => (
  <section styleName="container">
    {children}

    <CtaBlock {...topCtaBlock} isHuge />

    <div styleName="drag">
      <Projects {...projects} />
    </div>

    <CtaBlock {...bottomCtaBlock} />
  </section>
);
PortfolioPage.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  topCtaBlock: CtaBlockType,
  bottomCtaBlock: CtaBlockType,
  projects: ProjectsType,
};
PortfolioPage.defaultProps = {
  children: undefined,
  topCtaBlock: {},
  bottomCtaBlock: {},
  projects: {},
};

export default CSSModules(PortfolioPage, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/portfolio/portfolio-page.jsx